import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import { useCommandeContext, changeValeur } from "../../contexts/CommandeContext";

export default function NumeroTelephone({ props }) {

	// Initialisation de l'état par défaut
	const [valeur, setValeur] = useState('');
	const [timer, setTimer] = useState(null);

	// Recupération de la commande et du dispatcher à partir du CommandeContext
	const { commande, dispatch } = useCommandeContext();

	useEffect(() => {
		// Initialisation de la valeur à partir de la commande dans le context
		setValeur(commande[props.id]);
	}, [commande, props.id]);

	function handleChange(key, value) {
		setValeur(value);

		clearTimeout(timer);
		const newTimer = setTimeout(() => {
			dispatch(changeValeur(key, value));
		}, 500);
		setTimer(newTimer);
	}

	return (
		<TextField
			required={props.required}
			disabled={props.disabled}
			id={props.id}
			name={props.id}
			label={props.label}
			placeholder={props.placeholder}
			value={valeur}
			onChange={e => { handleChange(props.id, e.target.value) }}
			fullWidth
		/>
	);
}